import { render, staticRenderFns } from "./FormExam.vue?vue&type=template&id=09b9e640&"
import script from "./FormExam.vue?vue&type=script&lang=js&"
export * from "./FormExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports